import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../api/client';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * Change your own password.  Opened only on request (the header menu, or the
 * banner AppLayout shows an account still on an issued password); `prompted`
 * adds the reason.  Cancel and the close button always close it.
 */
export default function ChangePasswordDialog({ open, prompted = false, onClose, onDone }) {
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (next !== again) { toast.error('The new passwords do not match'); return; }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { current_password: cur, new_password: next });
      toast.success('Password changed');
      setCur(''); setNext(''); setAgain('');
      if (onDone) await onDone();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Password could not be changed');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && onClose) onClose(); }}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>{prompted ? 'Set your own password' : 'Change password'}</DialogTitle>
        </DialogHeader>
        {prompted && (
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            This account is still on a password issued to it. Choose your own; Cancel leaves it for now.
          </p>
        )}
        <div className="space-y-3">
          <Input type="password" placeholder="Current password" value={cur} onChange={e => setCur(e.target.value)}
                 autoComplete="current-password" data-testid="cp-current" />
          <Input type="password" placeholder="New password (8+ characters, a letter and a digit)" value={next}
                 onChange={e => setNext(e.target.value)} autoComplete="new-password" data-testid="cp-new" />
          <Input type="password" placeholder="Repeat new password" value={again} onChange={e => setAgain(e.target.value)}
                 autoComplete="new-password" data-testid="cp-again" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="cp-later">Cancel</Button>
          <Button onClick={save} disabled={busy || !cur || !next} data-testid="cp-save">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
